import { Sheet } from '@sravni/react-design-system/lib/Sheet';
import { useIsMobile } from '@sravni/react-utils';
import React, { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import cn from 'classnames';
import { SCREENS, FIELD_NAME } from '../constants';
import type { AuthInlineFormProps } from '../types';

import { formatPhoneToDisplayView } from '../lib/formatPhoneToDisplayView';
import styles from './AuthInlineForm.module.scss';
import { ConsentsScreenContentMobile, ConsentsSubmitButton } from './ConsentsScreen';
import { OTPScreenContentMobile, OTPScreenFooterMobile } from './OTPScreen';

type Props = Pick<
    AuthInlineFormProps,
    | 'onClose'
    | 'onChangePhoneClick'
    | 'consentsScreenTitle'
    | 'onOTPScreenOpen'
    | 'advertisingCheckboxLabel'
    | 'onChangeAgreementAdvertising'
    | 'onChangeAgreementPersonalData'
    | 'onConsentsScreenOpen'
> & {
    currentScreen: ValuesOf<typeof SCREENS>;
    onConsentsSubmitClick?: React.MouseEventHandler<HTMLDivElement>;
    submitAttempt: number;
    setSubmitAttempt: React.Dispatch<React.SetStateAction<number>>;
    isDialogVisible: boolean;
    onReturnButtonClick: () => void;
};

export const AuthInlineFormMobileScreen = (props: Props) => {
    const {
        consentsScreenTitle,
        advertisingCheckboxLabel,
        onChangeAgreementAdvertising,
        onChangeAgreementPersonalData,
        onChangePhoneClick,
        onClose,
        onConsentsScreenOpen,
        onOTPScreenOpen,
        onConsentsSubmitClick,
        submitAttempt,
        isDialogVisible,
        currentScreen,
        onReturnButtonClick,
    } = props;

    const { watch } = useFormContext();
    const isMobile = useIsMobile();

    const [phone] = watch([FIELD_NAME.PHONE]);

    const sheetHeaderTitle = useMemo(() => {
        switch (currentScreen) {
            case SCREENS.OTP:
                return 'Введите код из СМС';
            case SCREENS.CONSENTS:
                return consentsScreenTitle;
            default:
                return null;
        }
    }, [consentsScreenTitle, currentScreen]);

    const sheetHeaderSubTitle = useMemo(() => {
        switch (currentScreen) {
            case SCREENS.OTP:
                return `Отправили код на номер ${formatPhoneToDisplayView(phone)}`;
            default:
                return undefined;
        }
    }, [currentScreen, phone]);

    return (
        <Sheet closable visible={isMobile && isDialogVisible} onClose={onClose}>
            <Sheet.Header
                title={sheetHeaderTitle}
                subtitle={sheetHeaderSubTitle}
                className={cn(styles.mobileOtpHeader)}
            />
            <Sheet.Content>
                {currentScreen === SCREENS.OTP && (
                    <OTPScreenContentMobile onChangePhoneClick={onChangePhoneClick} onOTPScreenOpen={onOTPScreenOpen} />
                )}
                {currentScreen === SCREENS.CONSENTS && (
                    <ConsentsScreenContentMobile
                        submitAttempt={submitAttempt}
                        checkboxLabel={advertisingCheckboxLabel}
                        onChangeAgreementAdvertising={onChangeAgreementAdvertising}
                        onChangeAgreementPersonalData={onChangeAgreementPersonalData}
                        onConsentsScreenOpen={onConsentsScreenOpen}
                    />
                )}
            </Sheet.Content>
            <Sheet.Footer>
                {currentScreen === SCREENS.OTP && <OTPScreenFooterMobile />}
                {currentScreen === SCREENS.CONSENTS && (
                    <ConsentsSubmitButton
                        onReturnButtonClick={onReturnButtonClick}
                        onConsentsSubmitClick={onConsentsSubmitClick}
                    />
                )}
            </Sheet.Footer>
        </Sheet>
    );
};
